// src/components/about/CompanyMission.js
import React from 'react';
import AnimateOnScroll from './AnimateOnScroll';

const CompanyMission = () => {
  return (
    <AnimateOnScroll>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto 60px auto',
        padding: '0 20px',
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
        }}>
          <h2 style={{
            fontSize: '1.8rem',
            fontWeight: 'normal',
            marginBottom: '30px',
            textAlign: 'left',
          }}>
            PlasticAnalytics is an AI platform building the next generation of microplastics analysis tools.
          </h2>

          <p style={{ fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '20px', color: '#4b5563' }}>
            We believe advancing human knowledge about microplastics is critical to understanding environmental and health impacts. From sample collection to identification, the tools that have accelerated access to knowledge about microplastics have catalysed research progress. Yet analytical methods haven't kept up.
          </p>

          <p style={{ fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '20px', color: '#4b5563' }}>
            Most laboratory analysis relies on manual identification processes. Scattered data across institutions. Results trapped in research papers and individual studies. Outdated within months.
          </p>

          <p style={{ fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '20px', color: '#4b5563' }}>
            By combining artificial intelligence with deep expertise in spectroscopy, we're drastically improving the speed and accuracy of microplastics analysis. And in doing so, unlocking progress on a level that hasn't been possible before.
          </p>
        </div>
      </div>
    </AnimateOnScroll>
  );
};

export default CompanyMission;